<template>
  <div class="bg-white vform position-relative">
    <div v-show="loading" class="load-bg">
      <span v-show="loading">
        <i class="spin ml-4" />
      </span>
    </div>
    <div class="row m-4 justify-content-center">
      <div class="col-lg-9 bg-white py-4">
        <navigate-user-back />
        <div class="mt-4">
          <h1>{{ $t("message.orderHistory") }}</h1>
        </div>
        <div
          v-if="chargesAdminFee"
          class="alert alert-primary p-4 mt-4 alert-color mx-4"
          :style="desktopStyles.alertInfoBackGround"
          role="alert"
        >
          <span class="pl-2" :class="isSushi && 'montserrat-500'" v-html="adminFeeMessage"></span>
        </div>
        <hr />
        <div class="container">
          <div v-for="(order, index) in pageOrders" :key="index" class="row">
            <div class="row col-sm-12 order-items">
              <div class="order-item-details col-sm-9">
                <div
                  class="color-gray fdate"
                  v-html="parseDate(order.ScheduledTime, order.StoreName, order.OrderNumber)"
                />
                <ul>
                  <li
                    v-for="(orderItem, index) in order.OrderItems"
                    :key="index"
                  >
                    {{ orderItem.Quantity }} x {{ orderItem.Name }}
                  </li>
                </ul>
              </div>
              <div class="col-sm-3">
                <div class="row order-item-cost text-left padding-5-left">
                  <span
                    >{{ $t("message.total") }}:
                    {{
                      (order.TotalExcludingTax + order.TotalTax) | formatMoney(currencySign)
                    }}</span
                  >
                </div>
                <div class="row order-item-cost text-left padding-5-left">
                  <span
                    >{{ taxLabel }} :
                    {{ order.TotalTax | formatMoney(currencySign) }}</span
                  >
                </div>
                <div class="row w-100">
                  <button
                    v-if="enableCancellation(order)"
                    :style="desktopStyles.btn"
                    type="button"
                    class="btn btn-primary btn-with-margins"
                    @click="showCancelConfirmDialog(order)"
                  >
                    {{ $t("message.requestToCancel") }}
                  </button>
                  <button
                    type="button"
                    :style="desktopStyles.btn"
                    class="btn btn-primary btn-with-margins"
                    :disabled="IsStoreClose"
                    @click="showReorderConfirm(order)"
                  >
                    {{ $t("message.reorder") }}
                  </button>
                </div>
              </div>
            </div>
            <div
              class="cancelrequested col-sm-12"
              v-if="order.OnlineOrderStatus == 12"
            >
              <h3>{{ $t("message.orderCancelRequest") }}</h3>
              <p class="text-danger">
                {{ order.OnlineOrderStatusDescription }}
              </p>
            </div>
            <div
              class="cancelrequested col-sm-12"
              v-else-if="order.OnlineOrderStatus == 10"
            >
              <h3>{{ $t("message.refunded") }}</h3>
              <p class="text-danger">
                {{ order.OnlineOrderStatusDescription }}
              </p>
            </div>
            <div class="col-sm-12">
              <hr />
            </div>
          </div>
          <div v-if="pageOrders.length == 0">
            <message :message="getNoOrderAvailable" />
          </div>
          <div v-if="showmeesage" class="m-6 centered">
            <div
              class="error shadow-md p-6 pr-10"
              style="min-width: 240px; text-align: center"
            >
              <p class="messagetext">
                {{ $t("message.CancellationNotPermited") }}
              </p>
            </div>
          </div>
        </div>
        <div class="order-pagination">
          <pagination
            v-model="page"
            :records="records"
            :per-page="perPage"
            :options="options"
            @paginate="paginateCallback"
          />
        </div>
      </div>
    </div>
    <confirm
      v-if="showConfirm"
      ref="reorderConfirm"
      :confirm-title="$t('message.reorder')"
      :proccessing="progressing"
      @confirmed="reorder"
      @close="closeConfirm"
    >
      <template slot="body">
        <p class="mx-3">{{ $t("message.reorderCurrentOrder") }} ?</p>
      </template>
    </confirm>
    <confirm
      v-if="showCancelConfirm"
      ref="cancelConfirm"
      :proccessing="progressing"
      :confirm-title="$t('message.requestToCancel')"
      @confirmed="cancelOrder"
      @close="closeCancelConfirm"
    >
      <template slot="body">
        <p class="mx-3">{{ $t("message.cancelCurrentOrder") }} ?</p>
      </template>
    </confirm>
  </div>
</template>

<script>
import Pagination from "vue-pagination-2";
import confirm from "../confirm.vue";
import shared from "../../sharedscripts/user/OrderHistory.js";
import Message from "./../shared/Message";
import navigateUserBack from "./partials/navigateUserBack";
import { mapGetters } from "vuex";
export default {
  components: {
    Pagination,
    Message,
    confirm,
    navigateUserBack
  },
  data() {
    return {
      page: 1,
      perPage: 3,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev",
        },
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false,
      storeClosed: false,
      showConfirm: false,
      showCancelConfirm: false,
      progressing: false,
      selectedOrder: {},
      showmeesage:false,
    };
  },
  computed: {
    ...shared.computed,
    ...mapGetters(["desktopStyles", "hqDoc", "currentStoreDoc"]),
    getNoOrderAvailable() {
      return this.$t("message.noOrderAvailable");
    },
    isSushi(){
      return this.hqDoc && this.hqDoc.IsSushiHub
    }

  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    },
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  mounted() {
    this.setStoreLoaded();
  },
  methods: {
    ...shared.methods,
  },
};
</script>
<style lang="scss" scoped>
.cancelrequested {
  text-align: center;
  padding-left: 15px;

  p {
    margin: 0;
  }
}
.required-logo {
  color: red;
}
.centered {
  position: relative;
  // top: 390px;
  left: 50%;
  transform: translate(-50%, -50%);
}
.success {
  background-color: #22bb33;
  border-radius: 10px;
  padding: 15px 15px;
}
.error {
  background-color: #bb2124;
  border-radius: 15px;
  padding: 5px 10px;
}
.messagetext {
  margin-bottom: 5px !important;
  color: white;
}
.messagebtn {
  text-align: right;
  margin-bottom: 5px !important;
  color: white;
  cursor: pointer;
}
</style>

